<router-outlet />
@if (analytics.canOfferConsent()) {
  @if (analytics.showPreferences()) {
    <section class="analytics-consent" aria-label="Analytics preferences">
      <p>Allow analytics cookies to help us understand how SahkaarX is used? Your choice is optional.</p>
      <button type="button" (click)="analytics.setConsent(true)">Accept analytics</button>
      <button type="button" (click)="analytics.setConsent(false)">Reject analytics</button>
    </section>
  } @else {
    <button class="analytics-preferences" type="button" (click)="analytics.showPreferences.set(true)">Analytics preferences</button>
  }
}
